module.exports = __webpack_public_path__ + "img/vector-4.4124fe12.svg";